import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Returns a setter for a single URL search param, preserving the rest. Sets the
 * param when `value` is truthy, deletes it when falsy (keeps URLs clean). Pass
 * `{ replace: true }` to avoid a history entry for high-frequency updates (e.g.
 * typing in a search box). Shared by the cryod overview + detail pages so their
 * URL-as-source-of-truth controls stay consistent.
 */
export function useSearchParamSetter() {
  const [, setSearchParams] = useSearchParams();
  return useCallback(
    (key: string, value: string, options?: { replace?: boolean }) => {
      setSearchParams((previous) => {
        const next = new URLSearchParams(previous);
        if (value) next.set(key, value);
        else next.delete(key);
        return next;
      }, options);
    },
    [setSearchParams],
  );
}
